<template>
  <div align="center">
    <div class="video_detail" v-loading="loading">
      <div class="video_study">
        <div class="player">
          <video id="myVideo" width="100%" height="100%" :src="now_video_url" controls="controls" @timeupdate="changePlay" @play="startPlay" @ended="endPlay">
            您的浏览器不支持 video 标签。
          </video>
        </div>
        <div class="section">
          <div class="list">
            <template v-for="(level_1_item, level_1_index) in detailData.items">
              <div class="item" @click="changeVideo(level_1_index+'')">
                <template v-if="level_1_item.children.length  > 0">
                  <img class="arrow" v-if="level_1_item.is_open" src="@/assets/item_up.png"/>
                  <img class="arrow" v-else src="@/assets/item_down.png"/>
                </template>
                <div :class="now_tid === level_1_item.tid ? 'name active':'name' ">{{level_1_item.name}}</div>

                <div v-if="level_1_item.record_status>0"
                     style="z-index:1; position:absolute; left:0; top:0; bottom:1px; right:0; background-color:rgba(114,118,123,0.16);">
                  <div v-if="level_1_item.record_status===1"
                       style="width:50%; height:100%; background-color:rgba(166,169,173,0.26);"></div>
                  <div v-if="level_1_item.record_status===2"
                       style="width:100%; height:100%; background-color:rgba(166,169,173,0.26);"></div>
                </div>
              </div>

              <template v-if="level_1_item.is_open===true"
                        v-for="(level_2_item, level_2_index) in level_1_item.children">
                <div class="item" @click="changeVideo(level_1_index+'-'+level_2_index)">
                  <div class="space"></div>
                  <template v-if="level_2_item.children.length  > 0">
                    <img class="arrow" v-if="level_2_item.is_open" src="@/assets/item_up.png"/>
                    <img class="arrow" v-else src="@/assets/item_down.png"/>
                  </template>
                  <div :class="now_tid === level_2_item.tid ? 'name active':'name' ">{{level_2_item.name}}</div>

                  <div v-if="level_2_item.record_status>0"
                       style="z-index:1; position:absolute; left:0; top:0; bottom:1px; right:0; background-color:rgba(114,118,123,0.16);">
                    <div v-if="level_2_item.record_status===1"
                         style="width:50%; height:100%; background-color:rgba(166,169,173,0.26);"></div>
                    <div v-if="level_2_item.record_status===2"
                         style="width:100%; height:100%; background-color:rgba(166,169,173,0.26);"></div>
                  </div>
                </div>

                <template v-if="level_2_item.is_open===true"
                          v-for="(level_3_item, level_3_index) in level_2_item.children">
                  <div class="item" @click="changeVideo(level_1_index+'-'+level_2_index+'-'+level_3_index)">
                    <div class="space"></div>
                    <div class="space"></div>
                    <div :class="now_tid === level_3_item.tid ? 'name active':'name' ">{{level_3_item.name}}</div>

                    <div v-if="level_3_item.record_status>0"
                         style="z-index:1; position:absolute; left:0; top:0; bottom:1px; right:0; background-color:rgba(114,118,123,0.16);">
                      <div v-if="level_3_item.record_status===1"
                           style="width:50%; height:100%; background-color:rgba(166,169,173,0.26);"></div>
                      <div v-if="level_3_item.record_status===2"
                           style="width:100%; height:100%; background-color:rgba(166,169,173,0.26);"></div>
                    </div>
                  </div>
                </template>

              </template>
            </template>

            <template v-if="!is_data">
              <div class="item">
                <div class="name">暂无数据</div>
              </div>
            </template>
          </div>
        </div>
      </div>

      <div class="video_content">
        <div class="title">{{detailData.name}}</div>
        <div class="info">{{detailData.detail}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import {APIRequest} from '@/api/api';

  export default {
    data() {
      return {
        loading: true,
        tid: this.$route.query.tid,
        class_tid: this.$route.query.class_tid ? this.$route.query.class_tid : 0,

        detailData: {},
        is_data: true,
        itemIndex: '', //列表index

        now_tid: null, //当前播放视频tid
        now_video_url: '', //当前播放的视频地址

        currentTime: 0,
        videoDrag: false
      };
    },
    created() {
      this.fetchDetail();
    },
    methods: {
      fetchDetail() {
        let self = this;
        let params = {tid: self.tid};
        self.loading = true;
        APIRequest('getVideoDetail', params, true).then(res => {
          self.loading = false;

          if (res.data.items.length === 0) {
            self.is_data = false;
          } else {
            let defaultItem = null;
            let itemIndex = '';
            if (res.data.items.length > 0) {
              defaultItem = res.data.items[0];
              defaultItem.is_open = true;
              itemIndex = '0';
              if (defaultItem && defaultItem.video_tid === '' && defaultItem.children.length > 0) {
                defaultItem = defaultItem.children[0];
                defaultItem.is_open = true;
                itemIndex = '0-0';
                if (defaultItem && defaultItem.video_tid === '' && defaultItem.children.length > 0) {
                  defaultItem = defaultItem.children[0];
                  itemIndex = '0-0-0';
                }
              }
            }

            if (itemIndex !== '' && defaultItem != null) {
              self.itemIndex = itemIndex;
              self.getVideoURL(defaultItem.tid, defaultItem.video_tid);
            }
          }

          self.detailData = res.data;
        }, err => {
          self.loading = false;
        });
      },
      // 获取视频播放地址
      getVideoURL: function (item_tid, video_tid) {
        let self = this;
        let params = {
          video_tid: video_tid
        }
        APIRequest('getVideoURL', params, true).then(res => {
          self.currentTime = 0;
          self.now_tid = item_tid;
          self.now_video_url = res.data.video_url;
        }, err => {
        });
      },
      changeVideo: function (itemIndex) {
        let self = this;

        let itemIndexs = itemIndex.split('-');
        let currentItem = null;
        if (itemIndexs.length === 1) {
          currentItem = self.detailData.items[itemIndexs[0]];
        } else if (itemIndexs.length === 2) {
          currentItem = self.detailData.items[itemIndexs[0]].children[itemIndexs[1]];
        } else if (itemIndexs.length === 3) {
          currentItem = self.detailData.items[itemIndexs[0]].children[itemIndexs[1]].children[itemIndexs[2]];
        }

        if (currentItem) {
          if (currentItem.video_tid === '') {
            currentItem.is_open = !currentItem.is_open;
          } else {
            self.itemIndex = itemIndex;

            if (self.now_tid !== currentItem.tid) {
              // 获取视频播放地址
              self.getVideoURL(currentItem.tid, currentItem.video_tid);
            }
          }
        }
      },
      startPlay: function (event) {
        let self = this;

        let itemIndexs = self.itemIndex.split('-');
        let currentItem = null;
        if (itemIndexs.length === 1) {
          currentItem = self.detailData.items[itemIndexs[0]];
        } else if (itemIndexs.length === 2) {
          currentItem = self.detailData.items[itemIndexs[0]].children[itemIndexs[1]];
        } else if (itemIndexs.length === 3) {
          currentItem = self.detailData.items[itemIndexs[0]].children[itemIndexs[1]].children[itemIndexs[2]];
        }

        // 添加播放记录
        let params = {
          video_course_tid: currentItem.video_course_tid,
          video_course_item_tid: currentItem.tid,
          status: 1,
          type: 2
        };
        if (self.class_tid > 0) {
          params.class_tid = self.class_tid;
        }

        APIRequest('addVideoLog', params, true).then(res => {
          if (currentItem.record_status === 0) {
            currentItem.record_status = 1;
          }
        }, err => {
        });
      },
      endPlay: function (event) {
        let self = this;

        let itemIndexs = self.itemIndex.split('-');
        let currentItem = null;
        if (itemIndexs.length === 1) {
          currentItem = self.detailData.items[itemIndexs[0]];
        } else if (itemIndexs.length === 2) {
          currentItem = self.detailData.items[itemIndexs[0]].children[itemIndexs[1]];
        } else if (itemIndexs.length === 3) {
          currentItem = self.detailData.items[itemIndexs[0]].children[itemIndexs[1]].children[itemIndexs[2]];
        }

        // 添加播放记录
        let params = {
          video_course_tid: currentItem.video_course_tid,
          video_course_item_tid: currentItem.tid,
          status: 2,
          type: 2
        }
        if (self.class_tid > 0) {
          params.class_tid = self.class_tid;
        }
        APIRequest('addVideoLog', params, true).then(res => {
          if (currentItem.record_status !== 2) {
            currentItem.record_status = 2;
          }
        }, err => {
        });
      },
      changePlay: function (event) {
        let self = this;

        let myVideo = document.getElementById('myVideo');
        if (self.videoDrag===true && myVideo.paused===false )
        {
          myVideo.pause();
          return;
        }

        let offsetTime = event.target.currentTime - self.currentTime;
        if (!self.videoDrag && offsetTime > 2.0) {
          console.log('拖动了');
          self.videoDrag = true;
          // 视频暂停
          myVideo.pause();

          self.$alert('首次播放不能拖动进度条', '温馨提示', {
            confirmButtonText: '确定',
            callback: action => {
              console.log('确定');
              self.videoDrag = false;
              self.currentTime = 0;
              myVideo.currentTime = 0;
              myVideo.play();
            }
          });
          return;
        }
        self.currentTime = event.target.currentTime;
      }
    }
  }
</script>

<style>
  .video_detail {
    position: relative;
    text-align: left;
    min-width: 1040px;
    max-width: 1300px;
    margin: 0 200px 20px 200px;
    padding: 0;
  }

  .video_detail .video_study {
    position: relative;
    display: block;
    margin-top: 20px;
    width: 100%;
    height: 500px;
    background-color: #8cc5ff;
  }

  .video_detail .video_study .player {
    display: inline-block;
    vertical-align: top;

    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 320px;

    background-color: #000;
  }

  .video_detail .video_study .section {
    display: inline-block;
    vertical-align: top;

    position: absolute;
    top: 0px;
    bottom: 0px;
    right: 0px;
    width: 320px;

    font-size: 12px;
    background-color: #131313;
  }

  .video_detail .video_study .section .list {
    box-sizing: border-box;
    height: 100%;
    padding: 20px 16px;
    overflow: auto;
    color: #c7c7c7;
    font-size: 14px;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .video_detail .video_study .section .list .item {
    position: relative;
    height: 30px;
    line-height: 30px;
    text-align: left;
    color: #ffffff;

    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;

    z-index: 999;

    cursor: pointer;

    margin-bottom: 0;
  }

  .video_detail .video_study .section .list .item .arrow {
    width: 20px;
    height: 20px;
    z-index: 999;
  }

  .video_detail .video_study .section .list .item .name {
    color: #ffffff;
    z-index: 999;
  }

  .video_detail .video_study .section .list .item .active {
    color: #3a8ee6;
  }

  .video_detail .video_study .section .list .item .space {
    margin-left: 20px;
    z-index: 999;
  }

  .video_detail .video_content {
    position: relative;
    height: auto;
    margin-bottom: 20px;
  }

  .video_detail .video_content .title {
    margin-top: 20px;
    height: 40px;
    line-height: 40px;
    font-size: 32px;
    color: #000000;
  }

  .video_detail .video_content .info {
    position: relative;
    margin-top: 10px;
    margin-bottom: 20px;
    line-height: 30px;
    font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/VideoCourse/Detail.vue